var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPieChart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4453 19.8594L17.1094 15.5234C17.6875 14.5703 17.9766 13.5469 17.9766 12.4531C17.9766 11.0625 17.5508 9.82812 16.6992 8.75C15.8477 7.67188 14.7656 6.96094 13.4531 6.61719V0.5C15.4219 0.75 17.207 1.42969 18.8086 2.53906C20.4102 3.64844 21.6758 5.07422 22.6055 6.81641C23.5352 8.55859 24 10.4375 24 12.4531C24 15.2031 23.1484 17.6719 21.4453 19.8594ZM6.14062 10.9297H0C0.34375 8.21094 1.48828 5.87891 3.43359 3.93359C5.37891 1.98828 7.71094 0.84375 10.4297 0.5V6.61719C9.38281 6.89844 8.47266 7.42578 7.69922 8.19922C6.92578 8.97266 6.40625 9.88281 6.14062 10.9297ZM6.11719 13.9531C6.46094 15.2656 7.17188 16.3477 8.25 17.1992C9.32812 18.0508 10.5625 18.4766 11.9531 18.4766C13.0469 18.4766 14.0703 18.1875 15.0234 17.6094L19.3594 21.9453C17.1719 23.6484 14.7031 24.5 11.9531 24.5C9.9375 24.5 8.05859 24.0352 6.31641 23.1055C4.57422 22.1758 3.14844 20.9102 2.03906 19.3086C0.929688 17.707 0.25 15.9219 0 13.9531H6.11719Z",
    fill: "#C7C9C7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChart);
export default __webpack_public_path__ + "static/media/pie_chart.848aedbe.svg";
export { ForwardRef as ReactComponent };